import React from "react";

/**
 * Minimal company-discovery illustration for Search empty states.
 * Brand palette: primary purple + lavender wash (inspired by undraw simplicity).
 * https://undraw.co — composition reference only; artwork is original.
 */
export default function SearchDiscoveryIllustration({ size = 168 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 168 168"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Company search illustration"
    >
      <circle cx="84" cy="84" r="78" fill="#F6F4FF" />
      <rect
        x="38"
        y="52"
        width="58"
        height="78"
        rx="8"
        fill="#FFFFFF"
        stroke="#4A2CF5"
        strokeWidth="2"
      />
      <rect x="48" y="64" width="14" height="12" rx="2" fill="#775EFF" opacity="0.55" />
      <rect x="68" y="64" width="14" height="12" rx="2" fill="#775EFF" opacity="0.35" />
      <rect x="48" y="84" width="14" height="12" rx="2" fill="#775EFF" opacity="0.35" />
      <rect x="68" y="84" width="14" height="12" rx="2" fill="#775EFF" opacity="0.55" />
      <rect x="48" y="104" width="14" height="12" rx="2" fill="#775EFF" opacity="0.55" />
      <rect x="68" y="104" width="14" height="12" rx="2" fill="#775EFF" opacity="0.35" />
      <path
        d="M58 130h18v-12c0-3.3-2.7-6-6-6h-6c-3.3 0-6 2.7-6 6v12z"
        fill="#4A2CF5"
      />
      <circle
        cx="112"
        cy="78"
        r="26"
        fill="#FFFFFF"
        stroke="#4A2CF5"
        strokeWidth="3"
      />
      <circle cx="112" cy="78" r="12" stroke="#775EFF" strokeWidth="2.5" fill="none" />
      <path
        d="M130 96l14 14"
        stroke="#4A2CF5"
        strokeWidth="4"
        strokeLinecap="round"
      />
      <circle cx="128" cy="48" r="4" fill="#4A2CF5" opacity="0.35" />
      <circle cx="42" cy="44" r="3" fill="#775EFF" opacity="0.45" />
    </svg>
  );
}
